export default {"src":"/_next/static/media/how-2.e841e0f5.svg","height":103,"width":114,"blurWidth":0,"blurHeight":0};